import React from 'react';

import { Avatar, IconButton, type IconButtonProps } from '@mui/material';

import type { GetUserQuery } from '../../../../gql/graphql';

type UserMenuButtonProps = Omit<IconButtonProps, 'children'> & {
  handleOpenPopover: (event: React.MouseEvent<HTMLElement>) => void;
  selected: boolean;
  data: GetUserQuery | undefined;
};

export const UserMenuButton = React.forwardRef<HTMLButtonElement, UserMenuButtonProps>(
  ({ handleOpenPopover, selected, data, ...rest }, ref) => {
    return (
      <IconButton
        {...rest}
        onClick={handleOpenPopover}
        disableRipple
        sx={{
          borderRadius: '0',
          '&:hover': { backgroundColor: 'primary.main' },
          backgroundColor: selected ? 'primary.main' : '',
        }}
        ref={ref}
      >
        <Avatar alt={data?.me?.displayName || 'User'} src={data?.me?.images?.medium || '/static/avatar.jpg'} />
      </IconButton>
    );
  },
);
